module.exports = __webpack_public_path__ + "img/free-instagram-logo-icon-3497-thumb.a2cd788b.png";